import { RootState } from 'editor/src/store/index';

const getSidebarPayload = (state: RootState) => state.editorModules.sidebar.payload;

export default getSidebarPayload;
